// (c) 2026 Owl Consultations. All rights reserved.
// Proprietary and confidential — licensed use only. Unauthorized use,
// copying, or distribution is prohibited and may be prosecuted.

// PatientLanguageBadge — the language badge (ASP #9) for any CareRx table that knows the patient's id.
// The language comes from ONE cached list (useCareRxPatientLanguages), so a table needs no SQL of its
// own to show it. A CareRx patient missing from the loaded list has no usable Pioneer language and gets
// the "not detected" badge; nothing renders until the list has loaded. Renders LanguageBadge, which
// also hides a value masked for the viewer's role.

import { useCareRxPatientLanguages } from '../../hooks/queries/patientLanguages'
import LanguageBadge from './LanguageBadge'

export default function PatientLanguageBadge({ patientId }: { patientId?: string | null }) {
  const { data } = useCareRxPatientLanguages()
  if (!patientId || !data) return null
  return <LanguageBadge language={data.get(patientId.toLowerCase()) ?? null} />
}
